import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { removeFromWishlist } from "../../Redux_Store/actions";

const Wishlist = () => {
  const selectWishlist = useSelector((state) => {
    return state.WishlistReducer;
  });
  function generateRandomNumber() {
    return Math.floor(Math.random() * 50) + 1;
  }
  const dispatch = useDispatch();

  return (
    <div className="wishlist-container">
      {selectWishlist.map((item) => {
        return (
          <div key={item.id}>
            <div class="group h-60 block bg-gray-100 rounded-lg overflow-hidden shadow-lg m-4 relative mb-2 lg:mb-3">
              <img
                src={item.img}
                loading="lazy"
                alt="img"
                class="w-48 h-60 object-cover object-center group-hover:scale-110 transition duration-200"
              />

              <div class="flex gap-2 absolute left-0 bottom-2">
                <span class="bg-red-500 text-white text-sm font-semibold tracking-wider uppercase rounded-r-lg px-3 py-1.5">
                  -{generateRandomNumber()}%
                </span>
                <span class="bg-white text-gray-800 text-sm font-bold tracking-wider uppercase rounded-lg px-3 py-1.5">
                  New
                </span>
                <button
                  className="bg-white flex-none flex items-center justify-center w-7 h-7 rounded-md text-slate-300 border border-slate-200 ml-4"
                  type="button"
                  aria-label="Like"
                  onClick={() => dispatch(removeFromWishlist(item.id))}
                >
                  <svg
                    width="20"
                    height="20"
                    fill="currentColor"
                    aria-hidden="true"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M3.172 5.172a4 4 0 015.656 0L10 6.343l1.172-1.171a4 4 0 115.656 5.656L10 17.657l-6.828-6.829a4 4 0 010-5.656z"
                    />
                  </svg>
                </button>
              </div>
            </div>

            <div class="flex justify-between items-start gap-2 px-2">
              <div class="flex flex-col">
                <div class="text-gray-800 hover:text-gray-500 text-lg lg:text-xl font-bold transition duration-100">
                  {item.name}
                </div>
                <span class="text-gray-500">by Fancy Brand</span>
              </div>

              <div class="flex flex-col items-end">
                <span class="text-gray-600 lg:text-lg font-bold">
                  ${item.price}
                </span>
                <span class="text-red-500 text-sm line-through">
                  ${item.price + 10}
                </span>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default Wishlist;
